import React from 'react'
import canUseDOM from "can-use-dom";
import ClubTeaserList from './ClubTeaserList'
import ClubDetail from './ClubDetail'
import PlayHQMapFinder from './services/PlayHQMapFinder'
import GeocodeService from './services/GeocodeService'
import FilterComponent from './FilterComponent'
import ClubInfoWindow from './ClubInfoWindow'
import Querystring from 'query-string'
import MapControl from './MapControl'
import { isEmpty, isElementInViewport, getParameterByName, isMobileWidth, getScreenHeight } from '../utils'
import { activateSearchClubsLink } from '../nav-search'
import axios from 'axios'
import {
  MOBILE_MAX_SIZE, MAP_PIN, MAP_PIN_SELECTED, MAP_CLUSTER_STYLES, DEFAULT_QUERY_DISTANCE, FINDING_LOCATION_SPAN_TEXT,
  AU_CENTER_COORDINATES, POSTCODE_MATCHES, DEFAULT_LOCATION_SPAN_TEXT, MAP_PIN_STAR_SELECTED, MAP_PIN_STAR, PROGRAM_FORMAT_MAP,
 } from './data/Constants'

import {
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps'
import MarkerClusterer from '../../node_modules/react-google-maps/lib/components/addons/MarkerClusterer'


/** 
 * Set up our Map Component to be included in our club finder component below
 * Currently uses: https://github.com/tomchentw/react-google-maps
 * 
 * TODO: Update to a newer component - https://www.npmjs.com/package/@react-google-maps/api
*/
const MapComponent = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    zoom={props.mapZoom}
    defaultZoom={props.mapZoom}
    center={props.mapCenter}
    onClick={props.onMapClick}
    onDragEnd={props.onDragEnd}
    onDragStart={props.onDragStart}
    onBoundsChanged={props.onBoundsChanged}
    options={props.mapOptions}
    isMobile={props.isMobile}
    onZoomChanged={props.onZoomChanged}
    onProjectionChanged={props.onProjectionChanged}
    showProgramFilters={props.showProgramFilters}
    onDetailsClicked={props.onDetailsClicked}
  >
    <MapControl
      controlPosition={google.maps.ControlPosition.TOP_LEFT}>
        <div className="drag-control-container xs-hide">
          <input type="checkbox"
            id="drag-control-checkbox"
            checked={props.handleDragEnd}
            onChange={() => props.handleDragEndCheckbox()}/>
          <label htmlFor="drag-control-checkbox">Search as I move the map</label>
        </div>
      </MapControl>
    {props.markers &&
      <MarkerClusterer
       averageCenter
       enableRetinaIcons
       gridSize={80}
      //  maxZoom={18}
      // minimumClusterSize={5}
       styles={MAP_CLUSTER_STYLES}
     >
       {props.markers.map(marker => (
         <Marker
            {...marker}
            onClick={() => props.onMarkerClick(marker)}
            onRightClick={() => props.onMarkerRightClick(marker)}
          />
        ))}
      </MarkerClusterer>
    }
    {props.selectedClub && 
      props.selectedClub.position !== null &&
      ! props.isMobile &&
      <ClubInfoWindow
        club={props.selectedClub}
        onDetailsClicked={props.onDetailsClicked}
      />
    }
  </GoogleMap>
));



/**
Main entry class for our club finder component.

If a user has location services enabled in their browser and no parameters such as postcode, place or centreId are provided, the club finder component initiate
a search via the user's detected location.
Otherwise a user can search via location or centreName.  These are carried out by the included FilterComponent.

This component accepts the following querystring parameters:
postcode: an australian postcode.  If present, a search on location via postcode will be initiated.
place: a google maps api placeID.  If present, a search on google place id will be initiated
program: a comma separated list of program formats: eg: AUSKICK,AFL_9S,COMMUNITY.  If found, these will be appended to the programFilter which is passed to the search api
age: an age to search by - this will be added to the programFilter
gender: a gender to search on - currently may be MALE or FEMALE.  This will be added to the programFilter.
centreId: a centre id  as defined in PlayHQ.  If present, a search will be executed for the club with specified centreId
distance: an optional distance eg 10km to limit the search by.
inRegisterFlow: a parameter to let us know we are in a register user flow
*/
export default class ClubFinder extends React.Component {
  constructor(){
    super()

    this.parsedQueryString = Querystring.parse(location.search);
    let age = getParameterByName('age', this.parsedQueryString) || '';
    let gender = getParameterByName('gender', this.parsedQueryString);
    if (gender){
      gender = gender.toUpperCase()
    }
    let centreId = getParameterByName('centreId', this.parsedQueryString)
    let distance = getParameterByName('distance', this.parsedQueryString) || DEFAULT_QUERY_DISTANCE;
    let inRegisterFlow = getParameterByName('register', this.parsedQueryString) || false;
    
    this.filterComponent = React.createRef();
    
    this.state = {
      useBackupPostcodeFirst: false, // use backup postcode before any other option
      filter: null,
      center: { // default = center of Australia
        lat: -27.3945337,
        lng: 132.1237632
      },
      address:{ // provide a default address
        suburb: 'Melbourne',
        postcode: '3000',
        state: 'Vic'
      },
      femaleWarnIfNoResults: false,
      loadingResults: true,
      handleDragEnd: true,
      mapZoom: 12,
      showNoLocationDialog: false,
      showNoResultsDialog: true, // will not be displayed unless queryInitialised is true
      showRegistrationDeactivatedDialog: false,
      queryInitialised: false,
      userCentered: false, // Whether the user has manually recentered the map
      isListView: false, // whether it's a list view on mobile devices
      mapOptions: {
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        gestureHandling: 'greedy',
        streetViewControl: false,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
      },
      storedCenter: null,
      storedAddress: null,
      storedLocationInputValue: null,
      clubs: [],
      programFilter: { // our filter to pass to api
        age: age,
        gender: gender,
        centreId: centreId,
        distance: distance,
        program: [],
        suburb: null,
        centreName: null,
        nameSearch: centreId !== null,
        accessibility: false,
        filterCount: 0,
        distance: DEFAULT_QUERY_DISTANCE,
        apiToUse: null
      },
      locationInputValue: 'Finding Your Location',
      loadingPrograms: false, // are we loading programs?
      showProgramFilters: true,
      gotUserLocation: false,
      iconUrl: MAP_PIN,
      isAuskickRegisterPage: inRegisterFlow, // is this part of an auskick user registration flow
      showClubRegoWarning: inRegisterFlow,
      isMobileSize: isMobileWidth(),
      showStateRegistrationClosedDialog: false,
      showStateRegistrationClosedMessage: "",
      sendRegoReminder: true,
    };

  }

  componentWillMount(){
    let filterElement = document.getElementById('map-filter-program-type');
    
    if (filterElement){
      this.state.filter = filterElement.value
    } else {
      this.state.filter = null
    }
    let programFilter = this.state.programFilter;
    let baseElement = document.getElementById('map_locator')
    let apiToUse = baseElement.getAttribute('data-api-to-use')
    if (apiToUse){
      programFilter.apiToUse = apiToUse
    }

    let programType = baseElement.getAttribute('data-program-type')
    if (programType){ // map from old programs to new formats
      if (programType in PROGRAM_FORMAT_MAP){
        programType = PROGRAM_FORMAT_MAP[programType];
      }

      programFilter.program = [programType];
    }

    this.state.programFilter = programFilter;
    this.isHttps = window.location.protocol === 'https:';
    this.checkSize()
  }

  componentDidMount(){
    window.addEventListener("resize", this.checkSize.bind(this));

    let height = document.getElementById('map-container').clientHeight;
    if (height >= 550){
      this.setState({
        mapZoom: 12
      })
    }

    this.geocodeService = new GeocodeService()

    let postcode = getParameterByName('postcode', this.parsedQueryString)
    let place = getParameterByName('place', this.parsedQueryString)
    let program = getParameterByName('program', this.parsedQueryString)

    if (program && program.length > 0){

      const programsArr = program.split(',');
      let programFilter = this.state.programFilter;
      programFilter.program = programsArr;
      this.setState({
        programFilter: programFilter
      })
    }

    if (place && place.length > 0){
      this.geocodeService.getPlace(place, this.gotPlaceResults.bind(this))
    } 
    else if (this.state.programFilter.centreId !== null){
      new PlayHQMapFinder(null, this.state.programFilter, this.getClubFromId.bind(this))
    }
    else if (postcode && postcode.length > 0){
      this.state.address.postcode = postcode
      this.geocodeService.getLocationForPostcode(postcode, this.processGeocodeResults.bind(this))
    } 
    else {
      if (canUseDOM && navigator.geolocation) {
        // Provide a dummy geolocation call as a weird workaround. This should result in the next call working.
        navigator.geolocation.getCurrentPosition(function () {}, function () {}, {timeout:30000});
        navigator.geolocation.getCurrentPosition(this.gotLocation.bind(this), this.noLocation.bind(this), {timeout:10000});
        this.setState({
          locationInputValue: FINDING_LOCATION_SPAN_TEXT
        })
      } else {
        this.setState({
          center: AU_CENTER_COORDINATES,
          userCentered: false,
          mapZoom: 4,
          showNoLocationDialog: true,
          locationInputValue: 'Enter Suburb'
        })
      }
    }
    
  }

  doLocationSearch(){
    if (this.state.storedCenter != null){
      this.setState({
        center: this.state.storedCenter,
        address: this.state.storedAddress,
        locationInputValue: this.state.storedLocationInputValue,
        storedCenter: null,
        storedAddress: null,
        storedLocationInputValue: null,
        selectedClub: null,
      }, () => {
        this.findPrograms();
      })
    } else {
      if (canUseDOM && navigator.geolocation) {
        // Provide a dummy geolocation call as a weird workaround. This should result in the next call working.
        navigator.geolocation.getCurrentPosition(function () {}, function () {}, {});
        navigator.geolocation.getCurrentPosition(this.gotLocation.bind(this), this.noLocation.bind(this), {timeout:10000});
        this.setState({
          locationInputValue: FINDING_LOCATION_SPAN_TEXT
        })
      }
    }
  }

  doNameSearch(){
    this.setState({
      storedCenter: this.state.center,
      storedAddress: this.state.address,
      storedLocationInputValue: this.state.locationInputValue,
    })
  }

  handleDragEndCheckbox(el){
    let searchOnMove = !this.state.handleDragEnd;

    let programFilter = this.state.programFilter;
    if (searchOnMove){
      programFilter.nameSearch = false;
    }

    this.setState({
      handleDragEnd: searchOnMove,
      programFilter: programFilter
    })
  }

  /** Callback after a search by CentreId is initiated */
  getClubFromId(filter, clubs) {

    let selectedClub = this.state.selectedClub
    let center = this.state.center
    let programFilter = this.state.programFilter;

    if (clubs.length > 0){
      selectedClub = clubs[0] // should only be one result

      center = selectedClub.position
      
      programFilter.centreName = selectedClub.name;

      activateSearchClubsLink()
    }

    this.setState({
      clubs: clubs,
      selectedClub: selectedClub,
      loadingPrograms: false,
      gotUserLocation: true,
      programFilter: programFilter,
      center: center
    }, () => {
      if (isMobileWidth()){
        let pan = getScreenHeight() * .30;
        this.map.panBy(0, pan)
      }
    })
  }

  onProjectionChanged(){

  }

  /** Taken from here: https://groups.google.com/g/google-maps-js-api-v3/c/hDRO4oHVSeM 
   * could potentially need this in the future
  getMapMaxDimensions(){
    const w = this.map.getDiv().offsetWidth;
    const h = this.map.getDiv().offsetHeight;

    const maxDimension = Math.max(w, h);
    const metersPerPx = 156543.03392 * Math.cos(this.map.getCenter().lat() * Math.PI / 180) / Math.pow(2, this.map.getZoom());
    return ((maxDimension / 2) * metersPerPx) / 1000; // in km
  }*/

  /* Callback after we have had place details returned */
  gotPlaceResults(result){
    // A hack for the times we get a result back that doesn't have
    // a valid postcode
    if (!result.address.postcode && typeof POSTCODE_MATCHES[result.address.suburb] !== 'undefined'){
      result.address.postcode = POSTCODE_MATCHES[result.address.suburb]
    }
  
    this.setState({
      locationInputValue: result.address.suburb + ', ' + result.address.state,
      center: result.center,
      address: result.address,
      gotUserLocation: true
    }, () => {
      this.findPrograms()
    })
  }

  onMapLoad(map) {
    this.map = map;
  }

  onDragEnd(evt) {

    if ( this.state.loadingPrograms === false && this.state.handleDragEnd){
      if (this.map){
        let mapCenter = this.map.getCenter()
        let center = {
          lat: mapCenter.lat(),
          lng: mapCenter.lng()
        }

        let programFilter = this.state.programFilter;
        programFilter.centreId = null;
        programFilter.centreName = null;
        programFilter.nameSearch = false;

        this.setState({
          center: center,
          loadingResults: true,
          clubs: [],
          selectedClub: null,
          programFilter: programFilter,
          userCentered: true,
          queryInitialised:false
        })

        this.geocodeService.getAddressDetails(center.lat, center.lng,
          this.processGeocodeResults.bind(this))
      }
    }
  }

  checkSize(){
    let isMobileSize = false
    if (document.body.clientWidth < MOBILE_MAX_SIZE){
      isMobileSize = true
    }

    this.setState({
      isMobileSize: isMobileSize
    })
  }

  onDragStart(evt){
    this.setState({
      selectedClub: null
    })
  }

  useMapFinderApi() {
    this.setState({
      loadingResults: true
    });

    new PlayHQMapFinder(this.state.center, this.state.programFilter, this.getClubs.bind(this))
  }

  getClubs(filter, clubs, error = null) {
    let selectedClub = null;
    if (this.state.programFilter.centreName){
        var self = this
        clubs.forEach((club) => {
          if (self.state.programFilter.centreName === club.name){
            selectedClub = club
          }
        })
    }

    this.setState({
      clubs: clubs,
      selectedClub: selectedClub,
      loadingResults: false
    }, function(){ console.log('finished loading results')});

  }

  /**
  Callback from the navigator location api
  */
  gotLocation(pos){
    this.setState({
      center: {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude
      },
      gotUserLocation: true
    })
    this.geocodeService.getAddressDetails(pos.coords.latitude, pos.coords.longitude,
      this.processGeocodeResults.bind(this));
  }

  /** Got results from our reverse geocode lookup */
  processGeocodeResults(result){

    var mapCenter = result.center;
    if (this.state.userCentered){
      mapCenter = this.state.center;
    }    

    if (isEmpty(result.address)){
      return; // nothing we can do here
    }
    this.setState({
      address: result.address,
      center: mapCenter,
      userCentered: false,
      locationInputValue: result.address.suburb + ', ' + result.address.state,
      gotUserLocation: true
    }, () => {
      
    });

    this.findPrograms();
  }

  noLocation(error){

    if (this.state.backupPostcode && this.state.backupPostcode.length > 0){
      this.state.address.postcode = this.state.backupPostcode
      this.geocodeService.getLocationForPostcode(this.state.backupPostcode, this.processGeocodeResults.bind(this))
    } else {

      this.setState({
        center: AU_CENTER_COORDINATES,
        userCentered: false,
        mapZoom: 4,
        showNoLocationDialog: true,
        locationInputValue: DEFAULT_LOCATION_SPAN_TEXT,
        gotUserLocation: true // hack so loader isn't displayed
      })
    }
  }

  /** Called when a user clicks on a club name in the teaser list or a map marker on the map */
  onClubSelected(club){

    if (this.state.selectedClub){
      // reset marker
      if (this.state.selectedClub.isBurst){
        this.state.selectedClub.icon = MAP_PIN_STAR
      } else {
        this.state.selectedClub.icon = MAP_PIN
      }

      this.setState({
        selectedClub: null
      })
    }

    if (club.isBurst){
      club.icon = MAP_PIN_STAR_SELECTED
    } else {
      club.icon = MAP_PIN_SELECTED
    }
 
    let center = club.position
    if (this.state.isMobileSize){
      center = this.calculateMobileCenter(center, this.map.getZoom())
    }

    this.setState({
      selectedClub: club,
      center: center
    })

  }

  /** Moves the map center up by an amount based on the screenheight so it isn't covered by the club details  */
  calculateMobileCenter(center, newZoom){

    let latlng = new google.maps.LatLng(center.lat, center.lng)

    let offset = getScreenHeight() * .3;
    let newCenter = this.offsetCenter(latlng, 0, offset, newZoom);

    return newCenter
  }


  offsetCenter(latlng, offsetx, offsety, newZoom) {

    var scale = Math.pow(2, newZoom);

    var worldCoordinateCenter = this.map.getProjection().fromLatLngToPoint(latlng);
    var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);

    var worldCoordinateNewCenter = new google.maps.Point(
        worldCoordinateCenter.x - pixelOffset.x,
        worldCoordinateCenter.y + pixelOffset.y
    );

    var newCenter = this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

    let center = {
      lat : newCenter.lat(),
      lng: newCenter.lng()
    }

    return center
  }

  onClubDeselected(club){
    if (club.isBurst){
      club.icon = MAP_PIN_STAR
    } else {
      club.icon = MAP_PIN
    }

    this.setState({
      selectedClub: null
    })
  }

  /* Callback function after we have done our api call */
  doAddProgramClubs(filter, clubs, errors) {
    if (clubs && clubs.length > 0){
      
      let selectedClub = null
      if (this.state.programFilter.centreName){
        var self = this
          clubs.forEach((club) => {
            if (self.state.centreName === club.name){
              selectedClub = club
            }
          })
      } 
      else if (clubs.length === 1){
        selectedClub = clubs[0];  // display full details of the 1 club we have
      }
      
      this.setState({
        selectedClub: selectedClub,
        clubs: clubs,
        loadingPrograms: false
      });

    } else {
      this.setState({
        loadingPrograms: false,
        showNoResultsDialog: true
      })
    }
  }

  findPrograms(locationValue = null){
    let programFilter = this.state.programFilter

    let newZoom = this.map.getZoom();
    if (newZoom < 6){ // if we are zoomed out, bring it in.
      newZoom = 12;
    }

    this.setState({
      programs: [],
      clubs: [],
      selectedClub: null,
      mapZoom: newZoom,
      showNoResultsDialog: false
    }, () => {
      this.findClubsWithPlayHQ(programFilter)
    })
  }

  findClubsWithPlayHQ(programFilter){
    let femaleWarnIfNoResults = false;

    if (programFilter.gender === 'females') femaleWarnIfNoResults = true;
    var self = this
    this.setState({
      femaleWarnIfNoResults: femaleWarnIfNoResults,
      queryInitialised: true,
      loadingPrograms: true
    }, () => {
      new PlayHQMapFinder(this.state.center,
        programFilter, this.doAddProgramClubs.bind(this), null);
    })
  }

  /* updates the filters without running a query */
  updateFilters(programFilter){
    this.setState({
      programFilter: programFilter,
      selectedClub: null
    })
  }

  /** Process our filters.
   * This function will be called whenever the user initiates a search, 
   * or if a centre is selected from the centre autocomplete control
   */
  processFilters(programFilter, placeId, locationValue, selectedCentre = null){
    let showNoLocationDialog = this.state.showNoLocationDialog
    if (placeId){
      showNoLocationDialog = false
    }
    else if (locationValue === DEFAULT_LOCATION_SPAN_TEXT){
      showNoLocationDialog = true;
    }

    let mapZoom = this.state.mapZoom;
    let center = this.state.center;
    let clubs = []
    if (selectedCentre !== null){
      if (selectedCentre.position !== null){
        clubs.push(selectedCentre);
        mapZoom = 14;
        center = selectedCentre.position
        if (this.state.isMobileSize){
          center = this.calculateMobileCenter(center, mapZoom)
        }
      }
      showNoLocationDialog = false;
    }

    this.setState({
      programFilter: programFilter,
      clubs: clubs,
      selectedClub: selectedCentre,
      mapZoom: mapZoom,
      center: center,
      showNoLocationDialog: showNoLocationDialog,
      showStateRegistrationClosedDialog: false // reset this
    }, () => {
      if (selectedCentre !== null) return;

      if (placeId){
        this.geocodeService.getPlace(placeId, this.gotPlaceResults.bind(this))
      }
      else {
        this.findPrograms(locationValue); // just use what we have
      }
    })
  }

  onZoomChanged(){
    //this.getMapMaxDimensions();
    this.setState({
      mapZoom: this.map.getZoom()
    })
  }

  closeNoLocationDialog(e){
    this.setState({
      showNoLocationDialog: false
    })
  }

  checkCloseLocationDialog(e){
    if (e.which === 13){
      this.closeNoLocationDialog(e);
    }
  }

  onCloseRegoPopupClicked(e){
    this.filterComponent.current.focusLocationSpan()
    this.setState({
      showClubRegoWarning: false
    })
  }

  checkCloseRegoPopup(e){
    if (e.which === 13){
      this.onCloseRegoPopupClicked(e);
    }
  }

  doFilterFocused(){
    this.setState({
      showClubRegoWarning: false
    })
  }

  onViewTypeChange(isListView){
    this.setState({
      isListView: isListView
    })
  }

  closeStateRegistrationClosedDialog(e){
    this.setState({
      showStateRegistrationClosedDialog: false
    });

    if (this.state.sendRegoReminder == false){
      axios.get('/ajax/auskick-rego/opt-out')
        .then(function(resp){
          console.log(resp)
        })
    }
  }

  checkCloseStateRegistrationDialog(e){
    if (e.which === 13){
      this.closeStateRegistrationClosedDialog(e);
    }
  }

  closeNoResultsDialog(e){
    this.setState({
      showNoResultsDialog: false
    })
  }

  checkCloseNoResultsDialog(e){
    if (e.which === 13){
      this.closeNoResultsDialog(e);
    }
  }

  closeRegistrationDeactivatedDialog(e){
    this.setState({
      showRegistrationDeactivatedDialog: false
    })
  }

  showRegistrationDeactivatedModal(){
    this.setState({
      showRegistrationDeactivatedDialog: true
    })
  }

  handleSendReminderCheckbox(e){
    this.setState({
      sendRegoReminder: ! this.state.sendRegoReminder
    })
  }
  doNothing(e){}

  /**
  Determines whether we should display a dialog, and if so which one
  */
  renderDialogs(showLoader){

    // only show the loader if the map is in the viewport
    let locatorInViewport = isElementInViewport(document.getElementById('club-finder'));
    let noResultsMessage = <p className="map-modal-text">Sorry, there are no results for your selection.
    Please try a different area or broadening your gender and age selections.</p>
    let noResultsModalClass = "map-modal map-no-results";

    if (this.state.femaleWarnIfNoResults){
      noResultsMessage = <p className="map-modal-text map-modal-female-text">Sorry, there are no results for your selection. Please try a different area or broadening your
      gender and age selections.<br/> New female teams are starting all the time. Email <a href="mailto:femalefootball@afl.com.au">femalefootball@afl.com.au</a> and we’ll advise on your closest club</p>
      noResultsModalClass += " female-no-results";
    } 

    let showNoResultsDialog = this.state.queryInitialised &&
      this.state.clubs.length == 0 &&
      this.state.loadingPrograms === false &&
      this.state.showNoResultsDialog &&
      this.state.selectedClub === null &&
      ! showLoader;

    let showModal = this.state.showNoLocationDialog ||
        this.state.showStateRegistrationClosedDialog ||
        showNoResultsDialog ||
        this.state.showRegistrationDeactivatedDialog ||
        (showLoader && locatorInViewport && ! this.state.showNoLocationDialog);

    const CLOSE_ICON = <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <title>Close</title><g id="Symbols" fill="none"><g id="Club-Details-360" fill="#9B9B9B"><g id="Icon/Close"><g id="Group-2"><path id="Rectangle-8" d="M12.657-.07l1.414 1.413L1.346 14.07-.07 12.658z"/><path id="Rectangle-8" d="M.038 1.58L1.452.163l12.728 12.73-1.414 1.413z"/></g></g></g></g>
    </svg>

    if (showModal){
      return (
          <div className="finder-modal-overlay">
            { this.state.showNoLocationDialog &&
              <div className="map-modal no-location-dialog">
              <a className="right close-modal" onClick={this.closeNoLocationDialog.bind(this)}>
                {CLOSE_ICON}
              </a>
                <img src="/sites/all/themes/play2016/images/map/Location_Fail.png" className="map-fail-icon" alt="Location Not Found"/>
                <p className="map-modal-text">Sorry,<br/>we couldn't find your location.<br/>
                  Please try a different area.</p>
                  <a className="btn btn-primary btn-blue btn-map-ok" tabIndex="1" onClick={this.closeNoLocationDialog.bind(this)} onKeyPress={this.checkCloseLocationDialog.bind(this)}>OK</a>
              </div>
            }

            { this.state.showStateRegistrationClosedDialog &&
              <div className="map-modal registration-dialog">
                <a className="right close-modal" onClick={this.closeStateRegistrationClosedDialog.bind(this)}>
                  {CLOSE_ICON}
                </a>
                <p className="map-modal-rego-heading">{this.state.showStateRegistrationClosedMessage}</p>
                <p className="map-modal-rego-text">
                  <input type="checkbox" checked={this.state.sendRegoReminder} onChange={this.handleSendReminderCheckbox.bind(this)} /> Send me an email reminder
                </p>
                <a className="btn btn-primary btn-map-ok" tabIndex="1" onClick={this.closeStateRegistrationClosedDialog.bind(this)} onKeyPress={this.checkCloseStateRegistrationDialog.bind(this)}>OK</a>
              </div>
            }

            { showLoader &&
              locatorInViewport &&
              ! this.state.showNoLocationDialog &&
              <div className="map-modal loading-dialog">
                <img src="/sites/all/themes/play2016/images/map/Map_Loader.gif" alt="Map Loading" className="map-loader-icon"/>
                <p>Finding Clubs</p>
              </div>
            }

            { showNoResultsDialog &&
              <div className={noResultsModalClass}>
                <a className="close-modal" onClick={this.closeNoResultsDialog.bind(this)}>
                  {CLOSE_ICON}
                </a>
                <img src="/sites/all/themes/play2016/images/map/Location_Fail.png" className="map-fail-icon" alt="No Results"/>
                {noResultsMessage}
                <a className="btn btn-primary btn-map-ok" tabIndex="1" onClick={this.closeNoResultsDialog.bind(this)} onKeyPress={this.checkCloseNoResultsDialog.bind(this)}>OK</a>
              </div>
            }

            {this.state.showRegistrationDeactivatedDialog &&
              <div className="map-modal map-registration-deactivated">
                <a className="close-modal" onClick={this.closeRegistrationDeactivatedDialog.bind(this)}>
                  {CLOSE_ICON}
                </a>
                <img src="/sites/all/themes/play2016/images/map/alert.svg" className="map-alert-icon" alt="Registration Deactivated"/>
                <h4>Player Registrations Closed</h4>
                <p>This centre is not taking player registrations at this time. Check back at a later date.</p>
                <a className="btn btn-primary btn-map-ok" onClick={this.closeRegistrationDeactivatedDialog.bind(this)}>OK</a>
              </div>
            }
        </div>
      )
    } if (this.state.showClubRegoWarning)
      return (
        <div className="club-rego-warning-modal">
          <a onClick={() => this.onCloseRegoPopupClicked()} className="close-rego-popup">
            {CLOSE_ICON}
          </a>
          <h2>Find a Place to Play</h2>
          <p>Choose a NAB AFL Auskick centre on the map to view details and register</p>
          <a onClick={() => this.onCloseRegoPopupClicked()} onKeyPress={this.checkCloseRegoPopup.bind(this)} tabIndex="1" className="btn btn-primary btn-blue btn-clode-club-rego-modal">Got It</a>
        </div>
      )
  }


  render(){
    let showLoader = this.state.loadingPrograms || ! this.state.gotUserLocation;

    let finderClasses = "club-finder";
    if (this.state.clubs.length === 0){
      finderClasses += " map-empty"; 
    }

    // only show the teaser list if there is no selected club, we have a list of clubs
    // and either we are not in a mobile view, or we are in a mobile view, but have list view turned on.
    let showTeaserList = ! this.state.selectedClub && this.state.clubs.length > 0
      && (! this.state.isMobileSize || (this.state.isMobileSize && this.state.isListView)) 
      && ! showLoader;

    return (
      <div className={finderClasses} id="club-finder">
        <div className="clearfix">
          {((this.state.showProgramFilters &&
            ! this.state.isMobileSize)) &&
            <FilterComponent
              ref={this.filterComponent}
              independent={false}
              processFilters={this.processFilters.bind(this)}
              doFilterFocused={this.doFilterFocused.bind(this)}
              updateFilters={this.updateFilters.bind(this)}
              programFilter={this.state.programFilter}
              locationInputValue={this.state.locationInputValue}
              isAuskickRegisterPage={this.state.isAuskickRegisterPage}
              doLocationSearch={this.doLocationSearch.bind(this)}
              doNameSearch={this.doNameSearch.bind(this)}
              onViewTypeChange={this.onViewTypeChange.bind(this)}
              popupLocation='bottom'
            />
          }

          <div id="map-container" className="map-component-container relative">
              {this.state.selectedClub &&
                  <ClubDetail
                    key={this.state.selectedClub.key}
                    club={this.state.selectedClub}
                    center={this.state.center}
                    onCloseClicked={this.onClubDeselected.bind(this)}
                    showRegistrationDeactivatedModal={this.showRegistrationDeactivatedModal.bind(this)}
                  />
              }
            {showTeaserList &&
              <ClubTeaserList
                clubs={this.state.clubs}
                center={this.state.center}
                onDetailsClicked={this.onClubSelected.bind(this)}
              />
            }
            <div className="map-container">
              <MapComponent
                containerElement={
                  <div style={{ height: `100%` }} />
                }
                mapElement={
                  <div style={{ height: `100%` }} />
                }
                onMapLoad={this.onMapLoad.bind(this)}
                onMapClick={this.doNothing.bind(this)}
                onDragEnd={this.onDragEnd.bind(this)}
                markers={this.state.clubs}
                mapCenter={this.state.center}
                mapZoom={this.state.mapZoom}
                mapOptions={this.state.mapOptions}
                onMarkerRightClick={this.doNothing.bind(this)}
                onMarkerClick={this.onClubSelected.bind(this)}
                onDetailsClicked={this.onClubSelected.bind(this)}
                onZoomChanged={this.onZoomChanged.bind(this)}
                onProjectionChanged={this.onProjectionChanged.bind(this)}
                selectedClub={this.state.selectedClub}
                handleDragEnd={this.state.handleDragEnd}
                centreNameInputValue={this.state.programFilter.centreName}
                handleDragEndCheckbox={this.handleDragEndCheckbox.bind(this)}
                onDragStart={this.onDragStart.bind(this)}
                isLoading={this.state.loadingResults}
                isMobile={this.state.isMobileSize}
              />
            </div>
          </div>
        </div>
        {this.state.isMobileSize &&
          ! this.state.selectedClub &&
          <FilterComponent
            independent={false}
            ref={this.filterComponent}
            processFilters={this.processFilters.bind(this)}
            doFilterFocused={this.doFilterFocused.bind(this)}
            programFilter={this.state.programFilter}
            locationInputValue={this.state.locationInputValue}
            isAuskickRegisterPage={this.state.isAuskickRegisterPage}
            updateFilters={this.updateFilters.bind(this)}
            onViewTypeChange={this.onViewTypeChange.bind(this)}
            goButtonText="Find Your Place to Play"
            popupLocation='bottom'
          />
        }
        {this.renderDialogs(showLoader)}
      </div>
    )
  }
}
